// extracted by css-extract-rspack-plugin
export default {"root":"hl5tC","input":"ln9TG"};